require('./bootstrap');

// import vue js
import Vue from 'vue'
window.Vue = Vue;
Vue.config.devtools = true
Vue.prototype.$eventBus = new Vue();
/*-------------------------------------------------*/
/* =  scroll to top
/*-------------------------------------------------*/
var to_top_icon = $('#top');
$(to_top_icon).hide();

$(window).scroll(function() {
    if ($(this).scrollTop() > 75) {
        to_top_icon.fadeIn();
    } else {
        to_top_icon.fadeOut();
    }
});

var top_ofset = $('header').height() + 40;

$('header nav ul a,.findout-more,.logo, .scroll-down, #top').smoothScroll({
    offset: -top_ofset,
    // one of 'top' or 'left'
    direction: 'top',
    // only use if you want to override default behavior
    scrollTarget: null,
    // fn(opts) function to be called before scrolling occurs.
    // `this` is the element(s) being scrolled
    beforeScroll: function() {},
    // fn(opts) function to be called after scrolling occurs.
    // `this` is the triggering element
    afterScroll: function() {},
    easing: 'easeInOutExpo',
    speed: 1000,
    // coefficient for "auto" speed
    autoCoefficent: 2,
    // $.fn.smoothScroll only: whether to prevent the default click action
    preventDefault: true
});

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
});
